export default "__VITE_ASSET__9d675f3f__"